import { ReactNode, useState } from 'react'
import { Button, createStyles, makeStyles, Typography } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronRight,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons'

type Props = {
  title: string
  children: ReactNode
  isOpen?: boolean
  level?: number
}

const useStyle = makeStyles(() =>
  createStyles({
    level: {
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingLeft: (props: Props) => `${1 * (props.level ?? 1)}em`,
    },
  })
)

export const SettingsSection = (props: Props) => {
  const styles = useStyle(props)
  const [open, setOpen] = useState(props.isOpen)

  return (
    <li className="settings-areas-section">
      <Typography variant="body2" color="textSecondary">
        <Button
          variant="text"
          color="inherit"
          className={`${styles.level}`}
          fullWidth
          onClick={() => setOpen((open) => !open)}
        >
          <FontAwesomeIcon
            icon={open ? faChevronDown : faChevronRight}
            size="sm"
          />
          &nbsp;{props.title}
        </Button>
      </Typography>
      {open && <ul>{props.children}</ul>}
    </li>
  )
}
